module.exports = __webpack_public_path__ + "img/category1.7b05aa44.jpg";